import type { AxiosResponse } from 'axios';
import type { DetailedRoute, MinimalStatusCollection, RouteMetadata, RoutesResult } from '@/generated/model';

export type ProcessedRoutesResult = {
  routes: DetailedRoute[];
  statuses: MinimalStatusCollection[];
  routeMetadata: RouteMetadata;
  actualToTime: Date;
};

export function processRoutesResult(result: RoutesResult): ProcessedRoutesResult {
  const routes = [...result.routes].sort((a, b) => a.startPosition.timeMicros - b.startPosition.timeMicros);
  const uniqueRoutes: DetailedRoute[] = [];
  let previousStartTime: number | undefined;

  for (const route of routes) {
    const startTime = route.startPosition.timeMicros;
    if (startTime === previousStartTime) {
      continue;
    }
    uniqueRoutes.push(route);
    previousStartTime = startTime;
  }

  return {
    routes: uniqueRoutes,
    statuses: result.statuses,
    routeMetadata: result.routeMetadata,
    actualToTime: new Date(result.routeMetadata.toTimeMicros / 1000),
  };
}

export function selectRoutesResult(response: AxiosResponse<RoutesResult>): ProcessedRoutesResult {
  return processRoutesResult(response.data);
}
